import m from 'mithril'
import moment from 'moment'
import {
    Dialog,
    TextBox
} from 'components'
import * as Components from 'components'
import Uploader from 'components/uploader/core'
import {
    Analization,
} from 'app/models'
import classNames from 'classnames';


export default class DashboardPage {
    constructor() {
        this.infos = new Analization()
        Analization.getDashboardInfo().then((response) => {
            this.infos = response
        })
        this.formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',

            // These options are needed to round to whole numbers if that's what you want.
            minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
            maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
        });
    }
    view() {
        return [
            m(".row",
                m(".col-xl-12",
                    m(".breadcrumb-holder", [
                        m("h3.main-title.float-left", "管理系統首頁"),
                        m("ol.breadcrumb.float-right",
                            [
                                m("li.breadcrumb-item.active", "首頁")
                            ]
                        ), m(".clearfix")
                    ])
                )
            ),
            m(".row", [
                m(".col-12.d-flex.align-items-end.border-bottom.py-2", [
                ]),
            ]),
            m(".row",
                [


                    m(".col-xs-12.col-md-12.col-lg-4.col-xl-4",
                        m(".card-box.noradius.noborder.bg-default",
                            [
                                m("i.lnr.lnr-user.float-right.text-white"),
                                m("h4.text-white.text-uppercase.m-b-20",
                                    "會員數"
                                ),
                                m("h1.m-b-20.text-white.counter",
                                    [this.infos.sumOfMembers, m('span.h6.pl-1', '個')]
                                ),
                                m("span.text-white.d-flex.justify-content-end.pr-4",
                                    ["一個月內新增", m('span.px-1', this.infos.sumOfMembersMonth), "位會員"]
                                )
                            ]
                        )
                    ),
                    m(".col-xs-12.col-md-12.col-lg-4.col-xl-4",
                        m(".card-box.noradius.noborder.bg-success",
                            [
                                m("i.lnr.lnr-user.float-right.text-white"),
                                m("h4.text-white.text-uppercase.m-b-20",
                                    "產生圖片數"
                                ),
                                m("h1.m-b-20.text-white.counter",
                                    [this.infos.sumOfPhotos, m('span.h6.pl-1', '人')]
                                ),
                                m("span.text-white.d-flex.justify-content-end.pr-4",
                                    ["一個月內新增", m('span.px-1', this.infos.sumOfPhotosMonth), "張"]
                                )
                            ]
                        ),
                    ),
                    m(".col-xs-12.col-md-12.col-lg-4.col-xl-4",
                        m(".card-box.noradius.noborder.bg-primary",
                            [
                                m("i.lnr.lnr-user.float-right.text-white"),
                                m("h4.text-white.text-uppercase.m-b-20",
                                    "產生文章數"
                                ),
                                m("h1.m-b-20.text-white.counter",
                                    [this.infos.sumOfArticles, m('span.h6.pl-1', '人')]
                                ),
                                m("span.text-white.d-flex.justify-content-end.pr-4",
                                    ["一個月內新增", m('span.px-1', this.infos.sumOfArticlesMonth), "筆"]
                                )
                            ]
                        )
                    ),
                    m(".col-xs-12.col-md-12.col-lg-4.col-xl-4",
                        m(".card-box.noradius.noborder.bg-info",
                            [
                                m("i.lnr.lnr-user.float-right.text-white"),
                                m("h4.text-white.text-uppercase.m-b-20",
                                    "付費數"
                                ),
                                m("h1.m-b-20.text-white.counter",
                                    [this.infos.sumOfPayMembers, m('span.h6.pl-1', '人')]
                                ),
                                m("span.text-white.d-flex.justify-content-end.pr-4",
                                    ["一個月內新增", m('span.px-1', this.infos.sumOfPayMembersMonth), "位"]
                                )
                            ]
                        )
                    ),


                    m(".col-xs-12.col-md-12.col-lg-4.col-xl-4",
                        m(".card-box.noradius.noborder.bg-secondary",
                            [
                                m("i.lnr.lnr-cross.float-right.text-white"),
                                m("h4.text-white.text-uppercase.m-b-20",
                                    "一個月登入次數"
                                ),
                                m("h1.m-b-20.text-white.counter",
                                    [this.infos.sumOfLoginMonth, m('span.h6.pl-1', '次')]
                                ),
                                m("span.text-white.d-flex.justify-content-end.pr-4",
                                    [m('span.px-1', "-")]
                                )
                            ]
                        )
                    ),

                ]
            ),

        ]
    }
}